import React from "react";

import { type VariableValue } from "@doitintl/cmp-models";
import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import { cloudflowTexts } from "../../../../../assets/texts";
import { type VariableScope } from "../../../types";
import VariableRow from "./VariableRow";

type Props = {
  variables: VariableValue[];
  onCreateVariable: (scope: VariableScope) => void;
  onDeleteVariable?: (variableId: string) => void;
  onEditVariable?: (variable: VariableValue) => void;
  scope: VariableScope;
};

const VariableTab = ({ variables, onCreateVariable, onDeleteVariable, onEditVariable, scope }: Props) => (
  <Stack sx={{ gap: 2, mt: 2 }} alignItems="flex-start">
    <Typography variant="body2" color="text.secondary">
      {scope === "global"
        ? cloudflowTexts.VARIABLES_TAB_GLOBAL_DESCRIPTION
        : cloudflowTexts.VARIABLES_TAB_LOCAL_DESCRIPTION}
    </Typography>

    <Button
      variant="outlined"
      color="primary"
      onClick={() => {
        onCreateVariable(scope);
      }}
      fullWidth={false}
    >
      {scope === "global" ? cloudflowTexts.CREATE_GLOBAL_VARIABLE : cloudflowTexts.CREATE_LOCAL_VARIABLE}
    </Button>

    {variables.length > 0 && (
      <TableContainer
        sx={{
          border: "1px solid",
          borderBottom: "0",
          borderColor: "general.divider",
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
        }}
      >
        <Table>
          <TableHead
            sx={{
              backgroundColor: "general.backgroundDark",
            }}
          >
            <TableRow>
              <TableCell>{cloudflowTexts.NAME}</TableCell>
              <TableCell>{cloudflowTexts.VALUE}</TableCell>
              {scope === "local" && <TableCell />}
            </TableRow>
          </TableHead>
          <TableBody>
            {variables.map((variable) => (
              <VariableRow
                key={variable.id}
                item={variable}
                onEdit={onEditVariable}
                onDelete={onDeleteVariable}
                scope={scope}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </Stack>
);

export default VariableTab;
